function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import map from 'lodash/map';
import flowFP from 'lodash/fp/flow';
import filterFP from 'lodash/fp/filter';
import mergeFP from 'lodash/fp/merge';
import keyByFP from 'lodash/fp/keyBy';
import text from '../../../text';
import CreateTable from '../../select/CreateTable';
import { ASSET_ICON_MAP } from '../../../constants/product';
var productOptions = map(ASSET_ICON_MAP, function(_, productKey) {
    return {
        productKey: productKey,
        label: productKey
    };
});
var getProductOption = function(productKey) {
    return productKey ? {
        productKey: productKey,
        label: productKey
    } : undefined;
};
var ProductSelect = function(props) {
    var onChange = props.onChange, product = props.product, existingProducts = props.existingProducts, isProductSelectionDisabled = props.isProductSelectionDisabled, placeholder = props.placeholder;
    var options = flowFP([
        filterFP(function(item) {
            return item.productKey;
        }),
        function(result) {
            return map(result, function(item) {
                return _object_spread(_object_spread_props(_object_spread({}, item), {
                    isDisabled: true
                }), getProductOption(item.productKey));
            });
        },
        keyByFP('productKey'),
        mergeFP(keyByFP('productKey')(productOptions)),
        function(result) {
            return map(result, function(item) {
                return _object_spread({}, item);
            });
        }
    ])(existingProducts);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CreateTable, {
        placeholder: placeholder,
        options: options,
        isDisabled: isProductSelectionDisabled,
        onChange: function(option) {
            var value = option.productKey ? option : getProductOption(option.value);
            onChange(value);
        },
        createInputPlaceholder: text('enterNewProduct'),
        getOptionValue: function(option) {
            return option.productKey;
        },
        value: getProductOption(product)
    }));
};
export default ProductSelect;
